import { useContext } from 'react';

import { BrandContext } from 'context/BrandContext';
import { isStandardVariant } from 'helpers/iconSizes';
import { ICON_SIZES } from 'lib/constants/iconSizes';

const Mountain = ({ svgSize = ICON_SIZES.MD, className = '' }) => {
  const { theme } = useContext(BrandContext);
  const isStandardVariantIcon = isStandardVariant(svgSize);

  if (isStandardVariantIcon) {
    return (
      <svg
        width={svgSize}
        height={svgSize}
        className={className}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.333 22.2744L20.667 18.0391L28 29.333H4L12 16.667L17.333 22.2744ZM22.667 4V8H16V4H22.667Z"
          fill={theme.icon.fill}
        />
        <path
          d="M16.0004 2C16.3684 2.00017 16.6674 2.29891 16.6674 2.66699V3.33398H22.6674C23.0351 3.33433 23.3332 3.63217 23.3334 4V8C23.3332 8.36783 23.0351 8.66664 22.6674 8.66699H16.6674V10.4717L21.2279 17.5654L28.5609 28.9736C28.6924 29.1787 28.7021 29.4395 28.5853 29.6533C28.4685 29.8671 28.244 29.9999 28.0004 30H4.00037C3.75673 30 3.53236 29.867 3.41541 29.6533C3.29861 29.4394 3.30814 29.1787 3.43982 28.9736L11.6097 16.2637L15.3334 10.4717V2.66699C15.3334 2.2988 15.6322 2 16.0004 2ZM5.22107 28.667H26.7797L20.6107 19.0732L17.8568 22.5674C17.7365 22.7196 17.5556 22.8121 17.3617 22.8203C17.1676 22.8284 16.9788 22.7513 16.8461 22.6094L12.2679 17.7061L5.22107 28.667ZM16.0004 12C15.9796 12 15.9591 11.995 15.9388 11.9932L13.0111 16.5488L17.2904 21.1309L19.849 17.8867L16.0609 11.9932C16.0409 11.995 16.0209 12 16.0004 12ZM16.6674 7.33398H22.0004V4.66699H16.6674V7.33398Z"
          fill={theme.icon.stroke}
        />
      </svg>
    );
  }

  return (
    <svg
      width={svgSize}
      height={svgSize}
      className={className}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.0837 36.7505L30.3337 32.0835L33.8337 34.9995L36.0173 32.6665L47.8337 49.0005H8.16675L20.9998 30.9165L25.0837 36.7505ZM39.6667 8.1665L37.3337 11.6665L39.6667 15.1665H27.9998V8.1665H39.6667Z"
        fill={theme.icon.fill}
      />
      <path
        d="M27.9998 4.9585C28.483 4.9585 28.8748 5.35025 28.8748 5.8335V7.2915H39.6667C39.9893 7.29162 40.286 7.46998 40.4382 7.75439C40.5902 8.03876 40.5731 8.38354 40.3943 8.65186L38.3845 11.6665L40.3943 14.6812C40.5732 14.9496 40.5904 15.2951 40.4382 15.5796C40.286 15.8639 39.9892 16.0414 39.6667 16.0415H28.8748V20.7212L36.9783 32.1616L48.5476 48.4946C48.7365 48.7615 48.7613 49.1124 48.6111 49.4028C48.4608 49.693 48.1605 49.8753 47.8337 49.8755H8.16675C7.83987 49.8755 7.53979 49.693 7.3894 49.4028C7.23919 49.1123 7.26397 48.7616 7.45288 48.4946L20.5808 29.9604L27.1248 20.7212V5.8335C27.1248 5.35033 27.5166 4.95863 27.9998 4.9585ZM9.85913 48.1255H46.1414L36.1365 34.0015L34.4392 35.6313C34.1178 35.9397 33.6155 35.9574 33.2732 35.6724L30.3513 33.2378L25.6648 37.4048C25.4705 37.5774 25.2089 37.6547 24.9519 37.6157C24.695 37.5767 24.4681 37.4251 24.3337 37.2026L21.2351 32.063L9.85913 48.1255ZM22.3396 30.5044L25.2888 35.396L29.7517 31.4302L29.8806 31.3354C30.1948 31.1451 30.6023 31.1692 30.8933 31.4116L33.7917 33.8267L35.113 32.5581L27.9988 22.5142L22.3396 30.5044ZM28.8748 14.2915H38.031L36.6052 12.1519C36.4094 11.858 36.4095 11.475 36.6052 11.1812L38.031 9.0415H28.8748V14.2915Z"
        fill={theme.icon.stroke}
      />
    </svg>
  );
};

Mountain.propTypes = {
  className: PropTypes.string,
  svgSize: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default Mountain;
